import React, { useEffect, useState } from "react";
import { getTraceByPatient } from "./patientApi";

const DeveloperToolsContent = ({
  patientId,
  trace: traceProp,
  traceLoading: traceLoadingProp,
  traceError: traceErrorProp,
}) => {
  const [traceLocal, setTraceLocal] = useState(null);
  const [loadingLocal, setLoadingLocal] = useState(false);
  const [errorLocal, setErrorLocal] = useState(null);

  const isControlled = traceLoadingProp !== undefined;

  useEffect(() => {
    if (isControlled || !patientId) return;

    let cancelled = false;

    const fetchTrace = async () => {
      setLoadingLocal(true);
      setErrorLocal(null);

      const traceResult = await getTraceByPatient(patientId);

      if (cancelled) return;

      if (traceResult?.error) {
        setErrorLocal(traceResult.error);
        setTraceLocal(null);
      } else {
        setTraceLocal(traceResult);
      }
      setLoadingLocal(false);
    };

    fetchTrace();
    return () => {
      cancelled = true;
    };
  }, [patientId, isControlled]);

  if (!patientId) {
    return (
      <p className="text-sm text-gray-600">
        Load a patient to view trace JSON for debugging.
      </p>
    );
  }

  const traceData = isControlled ? traceProp : traceLocal;
  const isLoading = isControlled ? traceLoadingProp : loadingLocal;
  const error = isControlled ? traceErrorProp : errorLocal;

  if (isLoading) {
    return <p className="text-sm text-gray-500">Loading trace…</p>;
  }

  if (error) {
    return <p className="text-sm text-red-600">{error}</p>;
  }

  if (traceData) {
    return (
      <pre className="text-xs bg-gray-50 border border-gray-300 rounded-md p-3 overflow-auto max-h-[70vh] whitespace-pre-wrap font-mono text-gray-800">
        {JSON.stringify(traceData, null, 2)}
      </pre>
    );
  }

  return <p className="text-sm text-gray-500">No trace data.</p>;
};

export default DeveloperToolsContent;
